<template>
  <div class="container" v-if="rmaProductDetail">
    <div class="row">
        <div class="col-sm-5">
            <h4 class="card-title mb-0">
              RMA - {{ rmaProductDetail.document_no }}
            </h4>
        </div><!--col-->
        <div class="col-sm-7">
            <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                <b-button size="sm" v-if="rmaProductDetail.action_buttons.downloadDeliveryNote"  variant="success ml-1" @click.stop.prevent="downloadDelivery(rmaProductDetail.document_no, rmaProductDetail.id)"><i class="fa fa-print"></i></b-button>
            </div><!--btn-toolbar-->
        </div><!--col-->
    </div><!--row-->
    <hr />
    <b-row>
      <b-col md="6" xs="12" >
        <p><b>{{ $t('marketplace.rma_product.document_no') }} :</b> {{ rmaProductDetail.document_no }}</p>
        <p><b>{{ $t('marketplace.rma_product.platform') }} :</b> {{ rmaProductDetail.platform }}</p>
        <p><b>{{ $t('marketplace.rma_product.platform_order_id') }} :</b> {{ rmaProductDetail.platform_order_id }}</p>
        <p><b>{{ $t('marketplace.rma_product.order_item_id') }} :</b> {{ rmaProductDetail.order_item_id }}</p>
        <p><b>{{ $t('marketplace.rma_product.imei_code') }} :</b> {{ rmaProductDetail.imei_code }}</p>
        <p><b>{{ $t('marketplace.rma_product.product_name') }} :</b> {{ rmaProductDetail.product_name }}</p>
        <p><b>{{ $t('marketplace.rma_product.remark') }} :</b> {{ rmaProductDetail.remark }}</p>
        <p><b>{{ $t('marketplace.rma_product.status') }} : </b> 
          <span v-html="rmaProductDetail.status_label"></span>
        </p>
      </b-col>
      <b-col md="6" xs="12">
        <p><b>{{ $t('marketplace.rma_product.conditions') }} :</b>
            {{ rmaProductDetail.conditions }}<br/>
        </p>
        <p><b>{{ $t('marketplace.rma_product.selling_price') }} :</b> {{ rmaProductDetail.selling_price }}</p>
        <p><b>{{ $t('marketplace.rma_product.deal_price') }} :</b> {{ rmaProductDetail.deal_price }}</p>
        <p><b>{{ $t('marketplace.rma_product.sold_date') }} :</b> {{ rmaProductDetail.sold_date }}</p>
        <p><b>{{ $t('marketplace.rma_product.qty') }} :</b> {{ rmaProductDetail.qty }}</p>
        <p><b>{{ $t('marketplace.rma_product.updated_at') }} :</b> {{ rmaProductDetail.updated_at }}</p>
        <p><b>{{ $t('marketplace.rma_product.created_at') }} :</b> {{ rmaProductDetail.created_at }}</p>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: 'RmaProductDetail',
  props: {
    rmaProductDetail: {
      type: Object
    }
  },
  methods: {
    downloadDelivery (documentNo, id) {
      this.axios.get('/marketplace/rma-product/' + id + '/download-dn', {
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = documentNo + '.pdf'
        link.click()
      }).catch(error => {
        console.log(error)
      })
    },
  }
}
</script>
